/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";

function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  dialogTitle,
  dialogContentText,
  isloading = false,
}) {
  const { t: uiT } = useUiTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
       
      PaperProps={{
        className: "rounded-2xl w-[420px] max-w-full",
      }}
    >
      <DialogTitle id="alert-dialog-title" className="pb-0">
        <h2 className="text-lg font-semibold text-gray-800">{dialogTitle}</h2>
      </DialogTitle>

      <DialogContent className="pt-2">
        <DialogContentText
          id="alert-dialog-description"
          className="text-sm text-gray-600"
        >
          {dialogContentText}
        </DialogContentText>
      </DialogContent>

      {!isloading ? (
        <div className="flex justify-end gap-4 px-6 pb-4 pt-2">
          <button
            onClick={onClose}
            className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded transition"
            >
            {uiT("annule")}
          </button>
          <button
            onClick={onConfirm}
            className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-4 py-2 rounded transition"
          >
            {uiT("domain-card.modal.confirm")}
          </button>
        </div>
      ) : (
        <div className="flex justify-center items-center px-6 pb-6 pt-4">
          <CircularProgress color="inherit" />
        </div>
      )}
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  dialogContentText: PropTypes.string.isRequired,
  isloading: PropTypes.bool,
};

export default ConfirmDialog;
